var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSixSitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 36,
    viewBox: "0 0 54 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320089"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 75",
    x: 13.1953,
    y: 9.05957,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 13.1953 9.05957)",
    fill: "url(#paint0_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    y: 22.5303,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 0 22.5303)",
    fill: "url(#paint1_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 44.1602,
    y: 22.5303,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 44.1602 22.5303)",
    fill: "url(#paint2_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    x: 13.1953,
    y: 36,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 13.1953 36)",
    fill: "url(#paint3_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 82",
    x: 29.5781,
    y: 9.05957,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 29.5781 9.05957)",
    fill: "url(#paint4_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 29.5781,
    y: 36,
    width: 8.74858,
    height: 8.88742,
    rx: 1.38866,
    transform: "rotate(-90 29.5781 36)",
    fill: "url(#paint5_linear_169_2707)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 74",
    x: 6.10938,
    y: 29.8896,
    width: 23.4684,
    height: 40.8266,
    rx: 1.38866,
    transform: "rotate(-90 6.10938 29.8896)",
    fill: "current",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_2707",
    x1: 22.0828,
    y1: 13.4338,
    x2: 13.1953,
    y2: 13.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "current"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_2707",
    x1: 4.37429,
    y1: 22.5303,
    x2: 4.37429,
    y2: 31.4177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "current"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_2707",
    x1: 48.5344,
    y1: 22.5303,
    x2: 48.5344,
    y2: 31.4177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "current"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_2707",
    x1: 22.0828,
    y1: 40.3743,
    x2: 13.1953,
    y2: 40.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986706,
    stopColor: "current"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_169_2707",
    x1: 38.4656,
    y1: 13.4338,
    x2: 29.5781,
    y2: 13.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "current"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_169_2707",
    x1: 38.4656,
    y1: 40.3743,
    x2: 29.5781,
    y2: 40.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986706,
    stopColor: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixSitter);
export default __webpack_public_path__ + "static/media/sixSitter.21bbeec3f20a56203f9dd0e14af10915.svg";
export { ForwardRef as ReactComponent };